export const REAL_ESTATE_EQUITY_SUMMARY_PROPORTION_CHART_VALUE_COLOR =
  '#284ECD';
export const REAL_ESTATE_EQUITY_SUMMARY_PROPORTION_CHART_DEBT_COLOR = '#0E32AB';
